export default __webpack_public_path__ + "865b255f4ac68abd016802325a4ef100.gif";